import {
  MONTHLY,
  MONTHLY_HASH_TAG,
} from '../../../common/components/PricingTemplate';

export const pricingPlans = (t) => ({
  [MONTHLY]: {
    hashTag: MONTHLY_HASH_TAG,
    free: {
      price: 0,
      header: {
        name: t('pricing.free.header'),
      },
      data: [
        true,
        true,
        true,
        false,
        false,
        false,
        t("pricing.free.data.typesBasic"),
        t('pricing.free.data.support'),
      ],
      link: {
        'text': t('pricing.free.link'),
      },
    },
    standard: {
      price: 11.99,
      header: {
        name: t('pricing.standard.header'),
      },
      data: [
        true,
        true,
        true,
        true,
        false,
        false,
        t("pricing.standard.data.typesBasicPro"),
        t('pricing.standard.data.support'),
      ],
      link: {
        'text': t('pricing.standard.link'),
      },
      noFreeDays: true,
    },
    advance: {
      price: 21.99,
      header: {
        name: t('pricing.advance.header'),
      },
      data: [
        true,
        true,
        true,
        true,
        true,
        true,
        t("pricing.standard.data.typesBasicPro"),
        t('pricing.advance.data.support'),
      ],
      link: {
        'text': t('pricing.standard.link'),
      },
      noFreeDays: true,
    },
  },
});
